import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useSettings } from '../context/SettingsContext';
import { FaSave, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import './SettingsManagement.css';

const SettingsManagement = () => {
  const { user } = useAuth();
  // Удаляем updateGiftSectionSetting, он больше не нужен здесь
  const { settings: globalSettings, refreshSettings, loading: settingsLoading } = useSettings(); 
  const [settings, setSettings] = useState({
    welcome_text: '',
    welcome_emoji: '',
    loyalty_emoji_beginner: '',
    loyalty_emoji_student: '',
    loyalty_emoji_expert: '',
    loyalty_emoji_master: '',
    loyalty_description: ''
  });
  const [componentLoading, setComponentLoading] = useState(true); // Переименовал loading на componentLoading
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [openSection, setOpenSection] = useState(''); // 'mainPageSettings', 'welcomeBotSettings', 'loyaltySettings'

  const [welcomeSetupLoading, setWelcomeSetupLoading] = useState(false);
  const [welcomeSetupMessage, setWelcomeSetupMessage] = useState('');

  // Функция handleResetToDefaults будет удалена
  // const handleResetToDefaults = () => {
  //   setSettings({
  //     welcome_text: 'Рад тебя видеть в своем медиа пространстве',
  //     welcome_emoji: '🌻',
  //     loyalty_emoji_beginner: '🌱',
  //     loyalty_emoji_student: '📚',
  //     loyalty_emoji_expert: '🎓',
  //     loyalty_emoji_master: '👑',
  //     loyalty_description: 'Это твой уровень лояльности. Совершай покупки и ты незаметно вырастешь до мастера!'
  //   });
  //   setSuccess(false);
  //   setError(null);
  // };

  const toggleSection = (sectionName) => {
    setOpenSection(prevOpenSection => prevOpenSection === sectionName ? '' : sectionName);
  };

  useEffect(() => {
    if (!settingsLoading) { 
      // console.log('[SettingsManagement] Global settings loaded, syncing to local state. globalSettings.isGiftSectionEnabled:', globalSettings.isGiftSectionEnabled); // Удаляем лог или изменяем ключ
      setSettings({
        welcome_text: globalSettings.welcome_text || 'Рад тебя видеть в своем медиа пространстве',
        welcome_emoji: globalSettings.welcome_emoji || '🌻',
        loyalty_emoji_beginner: globalSettings.loyalty_emoji_beginner || '🌱',
        loyalty_emoji_student: globalSettings.loyalty_emoji_student || '📚',
        loyalty_emoji_expert: globalSettings.loyalty_emoji_expert || '🎓',
        loyalty_emoji_master: globalSettings.loyalty_emoji_master || '👑',
        loyalty_description: globalSettings.loyalty_description || 'Это твой уровень лояльности. Совершай покупки и ты незаметно вырастешь до мастера!',
        // isGiftSectionEnabled: globalSettings.isGiftSectionEnabled !== undefined ? globalSettings.isGiftSectionEnabled : true, // Удаляем эту строку
      });
      setComponentLoading(false); 
    }
  }, [settingsLoading, globalSettings]); 

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    setSuccess(false);
    setError(null);
  };



  const handleSaveSettings = async () => {
    setSaving(true);
    setError(null);
    setSuccess(false);
    
    try {
      const telegramId = user?.telegramId || localStorage.getItem('telegram_id');
      
      const saveSettingValue = async (key, value, description) => {
        const response = await fetch(`/api/settings/${key}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'X-Telegram-ID': telegramId
          },
          body: JSON.stringify({ 
            value: value,
            description: description,
            group: 'general'
          })
        });
        
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(`Ошибка при сохранении настройки ${key}: ${errorData.message || response.statusText}`);
        }
        return await response.json(); // Возвращаем результат для возможного использования
      };

      // Сохраняем текстовые настройки
      await saveSettingValue('welcome_text', settings.welcome_text, 'Текст приветствия на главной странице');
      await saveSettingValue('welcome_emoji', settings.welcome_emoji, 'Эмодзи после имени пользователя');
      
      // Сохраняем настройки лояльности
      await saveSettingValue('loyalty_emoji_beginner', settings.loyalty_emoji_beginner, 'Эмодзи для уровня Новичок (0 покупок)');
      await saveSettingValue('loyalty_emoji_student', settings.loyalty_emoji_student, 'Эмодзи для уровня Студент (1 покупка)');
      await saveSettingValue('loyalty_emoji_expert', settings.loyalty_emoji_expert, 'Эмодзи для уровня Эксперт (2 покупки)');
      await saveSettingValue('loyalty_emoji_master', settings.loyalty_emoji_master, 'Эмодзи для уровня Мастер (3+ покупок)');
      await saveSettingValue('loyalty_description', settings.loyalty_description, 'Описание системы уровней');

      // Отдельно обновляем настройку раздела подарков через функцию из контекста - УДАЛЕНО
      // console.log('[SettingsManagement] Calling updateGiftSectionSetting with:', settings.isGiftSectionEnabled); 
      // await updateGiftSectionSetting(settings.isGiftSectionEnabled); // Удаляем эту строку
      
      // console.log('[SettingsManagement] Calling refreshSettings after all saves.'); // Убираем лог
      await refreshSettings(); 
      setSuccess(true);

    } catch (error) {
      console.error('Ошибка при сохранении настроек:', error);
      setError('Ошибка при сохранении настроек: ' + error.message);
    } finally {
      setSaving(false);
    }
  };

  const handleSetupWelcomeMessages = async () => {
    setWelcomeSetupLoading(true);
    setWelcomeSetupMessage('');
    setError(null); // Сбрасываем общую ошибку формы
    setSuccess(false); // Сбрасываем общее сообщение об успехе формы

    try {
      const telegramId = user?.telegramId || localStorage.getItem('telegram_id');
      if (!telegramId) {
        throw new Error('Не удалось получить Telegram ID пользователя.');
      }

      const response = await fetch('/api/settings/initiate-welcome-setup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Telegram-ID': telegramId
        }
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || data.message || `Ошибка ${response.status}`);
      }
      setWelcomeSetupMessage(data.message || 'Режим настройки активирован. Перейдите в бот.');
      // Попытка закрыть веб-приложение, чтобы пользователь мог легко перейти в бот
      if (window.Telegram && window.Telegram.WebApp) {
        window.Telegram.WebApp.close();
      }

    } catch (err) {
      console.error('Ошибка при инициации настройки приветствия:', err);
      setWelcomeSetupMessage(`Ошибка: ${err.message}`);
    } finally {
      setWelcomeSetupLoading(false);
    }
  };
  
  // Функция handleResetToDefaults удалена

  if (componentLoading || settingsLoading) { // Проверяем оба флага загрузки
    return (
      <div className="loading-state">
        <div className="loading-spinner"></div>
        <p>Загрузка настроек...</p>
      </div>
    );
  }

  return (
    <div className="settings-management">
      {/* Кнопка "Сохранить настройки" будет перемещена вниз */}

      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">Настройки успешно сохранены!</div>}

      <div className="settings-group">
        <h3 onClick={() => toggleSection('mainPageSettings')} className={openSection === 'mainPageSettings' ? 'open' : ''}>
          Настройки главной страницы
          {openSection === 'mainPageSettings' ? <FaChevronUp /> : <FaChevronDown />}
        </h3>
        <div className={`settings-content ${openSection === 'mainPageSettings' ? 'open' : ''}`}>
          <div className="setting-item">
            <label htmlFor="welcome_text">Текст приветствия:</label>
          <textarea
            id="welcome_text"
            name="welcome_text"
            value={settings.welcome_text}
            onChange={handleInputChange}
            rows="3"
          ></textarea>
          <p className="setting-description">Текст, который отображается после имени пользователя на главной странице.</p>
        </div>

        <div className="setting-item">
          <label htmlFor="welcome_emoji">Эмодзи после имени:</label>
          <input
            type="text"
            id="welcome_emoji"
            name="welcome_emoji"
            value={settings.welcome_emoji}
            onChange={handleInputChange}
          />
            <p className="setting-description">Эмодзи, которое отображается после имени пользователя. Можно использовать любой символ эмодзи.</p>
          </div>
          {/* Блок "Предпросмотр главной страницы" удален */}
          {/* Кнопка "Сбросить к значениям по умолчанию" удалена */}
        </div>
      </div>
      
      {/* Настройки раздела Подарки - УДАЛЕНО */}
      {/*
      <div className="settings-group">
        <h3 onClick={() => toggleSection('giftSettings')} className={openSection === 'giftSettings' ? 'open' : ''}>
          Настройки раздела "Подарки"
          {openSection === 'giftSettings' ? <FaChevronUp /> : <FaChevronDown />}
        </h3>
        <div className={`settings-content ${openSection === 'giftSettings' ? 'open' : ''}`}>
          <div className="setting-item">
            <label htmlFor="isGiftSectionEnabled" className="checkbox-label">
              <input
                type="checkbox"
                id="isGiftSectionEnabled"
                name="isGiftSectionEnabled"
                checked={settings.isGiftSectionEnabled}
                onChange={handleInputChange}
              />
              Включить раздел "Подарки" для пользователей
            </label>
            <p className="setting-description">Если включено, пользователи увидят кнопку "Подарки" и смогут покупать материалы в подарок.</p>
          </div>
        </div>
      </div>
      */}

      {/* Новый отдельный блок для настройки приветствия в боте */}
      <div className="settings-group welcome-bot-setup-block">
        <h3 onClick={() => toggleSection('welcomeBotSettings')} className={openSection === 'welcomeBotSettings' ? 'open' : ''}>
          Настройка приветствия в Telegram боте
          {openSection === 'welcomeBotSettings' ? <FaChevronUp /> : <FaChevronDown />}
        </h3>
        <div className={`settings-content ${openSection === 'welcomeBotSettings' ? 'open' : ''}`}>
          <div className="setting-item"> {/* Оставляем setting-item для консистентности отступов внутри группы, если нужно */}
            <button 
              type="button" 
              className="admin-button"
            onClick={handleSetupWelcomeMessages} 
            disabled={welcomeSetupLoading || saving}
          >
            {welcomeSetupLoading ? 'Отправка...' : 'Настроить приветствие бота'}
          </button>
          {welcomeSetupMessage && (
            <p className={welcomeSetupMessage.startsWith('Ошибка:') ? 'error-message' : 'success-message'}>
              {welcomeSetupMessage}
            </p>
          )}
          <p className="setting-description">
              Нажмите эту кнопку, чтобы получить в Telegram инструкции по настройке или обновлению сообщений, которые пользователи увидят при первом запуске бота (команда /start).
            </p>
          </div>
        </div>
      </div>

      <div className="settings-group">
        <h3 onClick={() => toggleSection('loyaltySettings')} className={openSection === 'loyaltySettings' ? 'open' : ''}>
          Настройки системы лояльности
          {openSection === 'loyaltySettings' ? <FaChevronUp /> : <FaChevronDown />}
        </h3>
        <div className={`settings-content ${openSection === 'loyaltySettings' ? 'open' : ''}`}>
          <div className="setting-item">
            <label htmlFor="loyalty_description">Описание системы лояльности:</label>
          <textarea
            id="loyalty_description"
            name="loyalty_description"
            value={settings.loyalty_description}
            onChange={handleInputChange}
            rows="3"
          ></textarea>
          <p className="setting-description">Текст, который показывается пользователю при наведении на иконку информации рядом с уровнем.</p>
        </div>

        <div className="setting-item">
          <label htmlFor="loyalty_emoji_beginner">Эмодзи для уровня "Новичок" (0 покупок):</label>
          <input
            type="text"
            id="loyalty_emoji_beginner"
            name="loyalty_emoji_beginner"
            value={settings.loyalty_emoji_beginner}
            onChange={handleInputChange}
          />
        </div>

        <div className="setting-item">
          <label htmlFor="loyalty_emoji_student">Эмодзи для уровня "Студент" (1 покупка):</label>
          <input
            type="text"
            id="loyalty_emoji_student"
            name="loyalty_emoji_student"
            value={settings.loyalty_emoji_student}
            onChange={handleInputChange}
          />
        </div>

        <div className="setting-item">
          <label htmlFor="loyalty_emoji_expert">Эмодзи для уровня "Эксперт" (2 покупки):</label>
          <input
            type="text"
            id="loyalty_emoji_expert"
            name="loyalty_emoji_expert"
            value={settings.loyalty_emoji_expert}
            onChange={handleInputChange}
          />
        </div>

        <div className="setting-item">
          <label htmlFor="loyalty_emoji_master">Эмодзи для уровня "Мастер" (3+ покупок):</label>
          <input
            type="text"
            id="loyalty_emoji_master"
            name="loyalty_emoji_master"
            value={settings.loyalty_emoji_master}
            onChange={handleInputChange}
          />
        </div>

        <div className="preview-block">
          <h4>Предпросмотр уровней лояльности:</h4>
          <div className="preview-content loyalty-preview">
            <div className="preview-level-item">
              <span className="preview-emoji">{settings.loyalty_emoji_beginner}</span>
              <span className="preview-level-name">Новичок</span>
              <span className="preview-level-desc">0 покупок</span>
            </div>
            <div className="preview-level-item">
              <span className="preview-emoji">{settings.loyalty_emoji_student}</span>
              <span className="preview-level-name">Студент</span>
              <span className="preview-level-desc">1 покупка</span>
            </div>
            <div className="preview-level-item">
              <span className="preview-emoji">{settings.loyalty_emoji_expert}</span>
              <span className="preview-level-name">Эксперт</span>
              <span className="preview-level-desc">2 покупки</span>
            </div>
            <div className="preview-level-item">
              <span className="preview-emoji">{settings.loyalty_emoji_master}</span>
              <span className="preview-level-name">Мастер</span>
              <span className="preview-level-desc">3+ покупок</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Перемещенная кнопка "Сохранить настройки" */}
      <button 
        className="add-button" 
        onClick={handleSaveSettings} 
        disabled={saving || componentLoading || settingsLoading}
        style={{ marginTop: '20px' }} // Добавим отступ сверху для кнопки
      >
        <FaSave /> {saving ? 'Сохранение...' : 'Сохранить настройки'}
      </button>
    </div>
  );
};

export default SettingsManagement;
